/* START_MODULE_CONTRACT
 * PURPOSE: Общие настройки полей ввода для прикладных форм (не auth): без автодополнения и подсказок браузера.
 * SCOPE: htmlInput props, mergeAppDataFieldSlotProps.
 * DEPENDS: нет
 * LINKS: M-FE-FEATURES, M-FE-APP
 * ROLE: UTILITY
 * MAP_MODE: EXPORTS
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * appDataFieldHtmlInputProps - базовые htmlInput-атрибуты для data-полей.
 * mergeAppDataFieldSlotProps - слияние slotProps TextField с базовыми настройками.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-13 - Отключение autocomplete/spellcheck для прикладных форм.
 * END_CHANGE_SUMMARY
 */

/** Значение autocomplete для полей, где браузер не должен подставлять сохранённые данные. */
export const APP_FORM_AUTOCOMPLETE = 'off';

/* START_METHOD_appDataFieldHtmlInputProps */
/* START_CONTRACT: appDataFieldHtmlInputProps
 * PURPOSE: Базовые атрибуты native input для прикладных форм (задачи, проекты и т.п.).
 * INPUTS: нет.
 * OUTPUTS: { object }.
 * SIDE_EFFECTS: нет.
 * LINKS: M-FE-APP
 * END_CONTRACT: appDataFieldHtmlInputProps
 */
export const appDataFieldHtmlInputProps = {
  autoComplete: APP_FORM_AUTOCOMPLETE,
  spellCheck: 'false',
  'data-lpignore': 'true',
  'data-1p-ignore': 'true',
  'data-form-type': 'other',
};
/* END_METHOD_appDataFieldHtmlInputProps */

/* START_METHOD_mergeAppDataFieldSlotProps */
/* START_CONTRACT: mergeAppDataFieldSlotProps
 * PURPOSE: Объединить пользовательские slotProps TextField с базовыми anti-autocomplete настройками.
 * INPUTS: { slotProps?: object }.
 * OUTPUTS: { object }.
 * SIDE_EFFECTS: нет.
 * LINKS: M-FE-APP
 * END_CONTRACT: mergeAppDataFieldSlotProps
 */
export function mergeAppDataFieldSlotProps(slotProps = {}) {
  return {
    ...slotProps,
    htmlInput: {
      ...appDataFieldHtmlInputProps,
      ...slotProps.htmlInput,
    },
  };
}
/* END_METHOD_mergeAppDataFieldSlotProps */
